import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const WEEKDAY_KEYS = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

const CampaignWeekProgress = ({ weekDays = [] }) => {
  const { t, i18n } = useTranslation();

  const labels = useMemo(() => {
    const monday = new Date();
    const day = monday.getDay();
    const diff = day === 0 ? -6 : 1 - day;
    monday.setDate(monday.getDate() + diff);

    return WEEKDAY_KEYS.map((key, index) => {
      const date = new Date(monday);
      date.setDate(monday.getDate() + index);
      const localized = date.toLocaleDateString(i18n.language || "fr-FR", {
        weekday: "short",
      });
      return t(`campaign.weekday.${key}`, {
        defaultValue: localized.replace(".", ""),
      });
    });
  }, [t, i18n.language]);

  return (
    <div className="campaign-progress-week-card">
      <h3 className="campaign-progress-week-card__title">
        {t("campaign.progressWeekTitle")}
      </h3>
      <div className="campaign-progress-week-card__days">
        {WEEKDAY_KEYS.map((key, index) => {
          const day = weekDays[index] || {
            status: "empty",
            detected: 0,
            treated: 0,
          };
          const { status, detected = 0, treated = 0 } = day;
          const showFraction = status === "complete" || status === "partial";

          return (
            <div key={key} className="campaign-progress-week-card__day">
              <span className="campaign-progress-week-card__day-label">
                {labels[index]}
              </span>
              <div
                className={`campaign-progress-week-card__circle campaign-progress-week-card__circle--${status}`}
              >
                {status === "complete" ? (
                  <i className="fas fa-check" aria-hidden />
                ) : null}
                {status === "partial" ? (
                  <i className="fas fa-bell" aria-hidden />
                ) : null}
              </div>
              {showFraction ? (
                <span
                  className={`campaign-progress-week-card__fraction campaign-progress-week-card__fraction--${status}`}
                >
                  {treated}/{detected}
                </span>
              ) : (
                <span className="campaign-progress-week-card__fraction-spacer" />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CampaignWeekProgress;
